module.exports = __webpack_public_path__ + "img/icon-binoculars-active.f0794e32.svg";